import { createApp, defineAsyncComponent } from 'vue';
import store from 'shared/store';
import { DsSkeletonBox } from '@coloplast/design-system';
import 'shared/styles/components/_c-content-library-page.scss';
import '@coloplast/design-system/dist/components/skeleton/ds-skeleton.css';

const contentLibrary = document.getElementById('content-library');
if (contentLibrary) {
    const app = createApp({
        name: 'ContentLibraryBlock',
    });
    app.use(store);
    app.component('ds-skeleton-box', DsSkeletonBox);
    app.component('content-library', defineAsyncComponent(
        () => import(/* webpackChunkName: "content-library" */ 'shared/components/contentLibrary/contentLibrary.vue')
    ));
    app.mount(contentLibrary);
}